(function () {
  var modal = document.getElementById('apply-now-ibe');
  if (!modal) return;

  var formId = modal.getAttribute('data-hs-form-id');
  var formStartSent = false;

  function pushEvent(name) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: name,
      form_id: formId,
      form_name: 'stylist_application',
    });
  }

  function isOpen() {
    return modal.style.display !== 'none' && modal.style.display !== '';
  }

  function syncScrollLock() {
    document.body.classList.toggle('apply-popup-open', isOpen());
  }

  function openPopup() {
    modal.style.display = 'flex';
    modal.style.visibility = 'visible';
    modal.style.opacity = '1';
    syncScrollLock();
  }

  document.addEventListener(
    'click',
    function (event) {
      var anchor = event.target.closest('a[href$="#apply-now-form"], a[href$="#apply-now-ibe"]');
      if (!anchor) return;
      event.preventDefault();
      event.stopPropagation();
      openPopup();
    },
    true
  );

  var openObserver = new MutationObserver(function () {
    syncScrollLock();
    if (!formStartSent && isOpen()) {
      formStartSent = true;
      pushEvent('form_start');
    }
  });
  openObserver.observe(modal, { attributes: true, attributeFilter: ['style'] });

  window.addEventListener('hs-form-event:on-submission:success', function (event) {
    var detail = event && event.detail;
    var submittedId = detail && (detail.formId || detail.form_id);
    if (submittedId && formId && submittedId !== formId) return;
    if (!submittedId && !isOpen()) return;
    pushEvent('form_complete');
  });

  var stepsLabel = modal.querySelector('[data-apply-popup-steps]');
  var currentEl = modal.querySelector('[data-apply-popup-step-current]');
  var totalEl = modal.querySelector('[data-apply-popup-step-total]');
  var progressFill = modal.querySelector('[data-apply-popup-progress]');

  function readSteps() {
    var progress = modal.querySelector('.hs-form-html [role="progressbar"]');
    if (progress && progress.hasAttribute('aria-valuenow') && progress.hasAttribute('aria-valuemax')) {
      return {
        current: parseInt(progress.getAttribute('aria-valuenow'), 10),
        total: parseInt(progress.getAttribute('aria-valuemax'), 10),
      };
    }
    var steps = modal.querySelectorAll('.hs-form-html .hsfc-Step');
    if (steps.length > 1) {
      var current = 0;
      steps.forEach(function (step, index) {
        if (step.offsetParent !== null) current = index + 1;
      });
      return { current: current || 1, total: steps.length };
    }
    return null;
  }

  var titleOverrides = {};
  var titlesScript = modal.querySelector('[data-apply-popup-titles]');
  if (titlesScript) {
    try {
      JSON.parse(titlesScript.textContent).split('\n').forEach(function (line) {
        var at = line.indexOf(':');
        if (at === -1) return;
        var key = line.slice(0, at).trim().toLowerCase();
        var title = line.slice(at + 1).trim();
        if (key && title) titleOverrides[key] = title;
      });
    } catch (e) {
    }
  }

  function stepFieldKey(content) {
    var fields = content.querySelectorAll('input, select, textarea');
    for (var i = 0; i < fields.length; i++) {
      if (fields[i].name && fields[i].name.indexOf('/') !== -1) {
        return fields[i].name.split('/').pop().toLowerCase();
      }
    }
    return null;
  }

  function stepLabelText(content) {
    var labels = content.querySelectorAll('label');
    for (var i = 0; i < labels.length; i++) {
      if (!labels[i].querySelector('input')) {
        return labels[i].textContent.replace(/\*\s*$/, '').trim();
      }
    }
    return null;
  }

  function ensureStepHeading() {
    var steps = modal.querySelectorAll('.hs-form-html .hsfc-Step');
    steps.forEach(function (step, index) {
      var content = step.querySelector('.hsfc-Step__Content') || step;
      if (content.querySelector('.apply-popup__question')) return;
      var key = stepFieldKey(content);
      var existing = content.querySelector('.hsfc-Heading, h1, h2, h3');
      var title = titleOverrides[String(index + 1)] || (key && titleOverrides[key]);
      if (title) {
        if (existing) existing.classList.add('apply-popup__hs-heading--replaced');
      } else if (existing) {
        return;
      } else {
        title = stepLabelText(content);
        if (!title) return;
      }
      var heading = document.createElement('h2');
      heading.className = 'apply-popup__question';
      heading.textContent = title;
      content.insertBefore(heading, content.firstChild);
    });
  }

  function updateSteps() {
    if (!stepsLabel) return;
    ensureStepHeading();
    var state = readSteps();
    if (state && state.total > 1 && state.current >= 1) {
      currentEl.textContent = state.current;
      totalEl.textContent = state.total;
      if (progressFill) {
        progressFill.style.width = Math.round((state.current / state.total) * 100) + '%';
      }
      stepsLabel.hidden = false;
    } else {
      stepsLabel.hidden = true;
    }
  }

  // HubSpot picks the phone country from the visitor's IP, so a US number entered
  // on a non-US connection is filed under the wrong dial code. setFieldValue sets a
  // value rather than a default region — emptying the field reverts it to the IP
  // country — so re-assert while the field holds no digits, and stop once the
  // visitor picks a country themselves.
  var BARE_DIAL_CODE = /^\s*(\+\d{1,3})?\s*$/;

  // Set once the field is wired up, so the render observer below can re-assert.
  var assertUsDefault = function () {};

  function defaultPhoneToUs() {
    var field = modal.querySelector('.hsfc-PhoneField');
    var input = field && field.querySelector('input[type="tel"]');
    if (!input || !window.HubSpotFormsV4) return;

    var countryPicked = false;
    field.addEventListener('click', function (event) {
      if (event.target.closest('.hsfc-DropdownOptions__List__ListItem')) countryPicked = true;
    });

    function assertUs() {
      if (countryPicked || input.value.trim() === '+1') return;
      if (!BARE_DIAL_CODE.test(input.value)) return;
      // This form is embedded twice on the page and the ready event does not say
      // which instance owns the modal. Setting on the wrong one is a silent no-op
      // — the reason the field used to sit on HubSpot's alphabetical fallback,
      // Albania — so set on every instance and let the right one take.
      window.HubSpotFormsV4.getForms().forEach(function (instance) {
        instance.setFieldValue('0-1/phone', '+1');
      });
    }

    assertUsDefault = assertUs;
    assertUs();
    // Deferred: calling setFieldValue synchronously here is clobbered by the
    // render HubSpot is already running for this same input event.
    input.addEventListener('input', function () {
      setTimeout(assertUs, 0);
    });
  }

  // HubSpot's step form does not gate NEXT on the current step's required fields.
  // Validation only runs at submit, so a visitor discovers a field they missed on
  // the last step, with nothing to say which step it belongs to. The v4 embed API
  // exposes no validate() hook, so gate the button here against HubSpot's own
  // aria-required markup.
  // Stricter than a bare "has an @ and a dot": rejects double dots, a leading or
  // trailing dot on either side of the @, a hyphen-edged domain label and a
  // single-character TLD — the shapes people actually mistype.
  var EMAIL_PATTERN = /^[^\s@.]+(?:\.[^\s@.]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i;
  // Placeholder domains — test.com, example.org, anything.invalid. HubSpot
  // refuses these at submit, so catch them at their own step instead. Matched on
  // whole labels, so a real domain like protest.com is unaffected.
  var PLACEHOLDER_LABELS = ['example', 'test', 'invalid', 'localhost'];

  function isPlaceholderDomain(domain) {
    var labels = domain.toLowerCase().split('.');
    var tld = labels[labels.length - 1];
    var name = labels[labels.length - 2];
    return PLACEHOLDER_LABELS.indexOf(tld) !== -1 || PLACEHOLDER_LABELS.indexOf(name) !== -1;
  }

  function isValidEmail(value) {
    return EMAIL_PATTERN.test(value) && !isPlaceholderDomain(value.split('@').pop());
  }
  // A floor, not a full check — HubSpot validates the number properly at submit
  // and returnToFirstError below covers whatever this lets through. No real
  // number is this short, so the floor cannot reject a valid one.
  var MIN_PHONE_DIGITS = 7;

  function nationalDigits(value) {
    var dialCode = value.match(/^\+(\d{1,3})/);
    return value.replace(/\D/g, '').length - (dialCode ? dialCode[1].length : 0);
  }

  function isNextButton(button) {
    var buttons = button.closest('.hsfc-NavigationRow__Buttons');
    if (!buttons) return false;
    // PREVIOUS is never last, and the final step ends in a submit button that
    // HubSpot validates itself.
    return button === buttons.lastElementChild && button.type === 'button';
  }

  // Every field sits in a block-level wrapper (TextField, EmailField, PhoneField,
  // DropdownField, RadioFieldGroup). The .hsfc-Row above it is a grid, so a
  // message appended there takes its own cell beside the field instead of
  // sitting under it.
  function errorHost(field) {
    if (!field || !field.closest) return null;
    return field.closest('[data-hsfc-id$="Field"], [data-hsfc-id$="FieldGroup"]');
  }

  function showError(field, text) {
    var host = errorHost(field);
    if (!host || host.querySelector('.apply-popup__error')) return;
    field.setAttribute('aria-invalid', 'true');
    var message = document.createElement('span');
    message.className = 'apply-popup__error';
    message.textContent = text;
    host.appendChild(message);
  }

  function clearError(field) {
    var host = errorHost(field);
    if (!host) return;
    var message = host.querySelector('.apply-popup__error');
    if (message) message.remove();
    host.querySelectorAll('[aria-invalid="true"]').forEach(function (input) {
      input.setAttribute('aria-invalid', 'false');
    });
  }

  function stepErrors(step) {
    var seenGroup = {};
    var errors = [];

    step.querySelectorAll('[aria-required="true"]').forEach(function (field) {
      if (field.type === 'hidden') return;

      if (field.type === 'radio' || field.type === 'checkbox') {
        if (seenGroup[field.name]) return;
        seenGroup[field.name] = true;
        if (!step.querySelector('input[name="' + field.name + '"]:checked')) {
          errors.push({ field: field, text: 'Please choose an option.' });
        }
        return;
      }

      var value = field.value.trim();
      // The phone field is pre-seeded with a dial code, which is not an answer.
      if (field.type === 'tel' && BARE_DIAL_CODE.test(value)) value = '';

      if (!value) {
        errors.push({ field: field, text: 'Please complete this field.' });
      } else if (field.type === 'email' && !isValidEmail(value)) {
        errors.push({ field: field, text: 'Please enter a valid email address.' });
      } else if (field.type === 'tel' && nationalDigits(value) < MIN_PHONE_DIGITS) {
        errors.push({ field: field, text: 'Please enter a valid phone number.' });
      }
    });

    return errors;
  }

  // Capture, so the click is stopped before HubSpot's own listener advances the step.
  modal.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('.hsfc-NavigationRow__Buttons button');
      if (!button || !isNextButton(button)) return;

      var step = button.closest('.hsfc-Step');
      if (!step) return;

      var errors = stepErrors(step);

      if (!errors.length) {
        // HubSpot has flagged something on this step that we cannot judge
        // ourselves — a rejected email domain, a number it reads as malformed.
        // Its own message is already on screen, and it clears the flag as soon
        // as the field is edited, so simply hold the visitor here.
        var flagged = step.querySelector('.hsfc-ErrorAlert') && step.querySelector('[aria-invalid="true"]');
        if (!flagged) return;
        event.preventDefault();
        event.stopPropagation();
        flagged.focus();
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      errors.forEach(function (error) {
        showError(error.field, error.text);
      });
      errors[0].field.focus();
    },
    true
  );

  modal.addEventListener('input', function (event) {
    clearError(event.target);
    maybeOfferReturn();
  });

  modal.addEventListener('change', function (event) {
    clearError(event.target);
    maybeOfferReturn();
  });

  // The checks above only cover what we can judge locally. HubSpot owns the rest
  // (phone format, rejected email domains) and runs them only at submit, then
  // renders the error on the step that owns the field — which by then is several
  // steps behind the visitor. Walk them back to the first offending step so they
  // land on the problem instead of hunting for it.
  var awaitingSubmitResult = false;
  var walkingBack = false;
  // The step the visitor was walked back from — the one holding the submit
  // button. -1 until a walk-back happens; reset once they are back on it.
  var returnTargetIndex = -1;

  function stepList() {
    return modal.querySelectorAll('.hs-form-html .hsfc-Step');
  }

  function currentStepIndex() {
    var steps = stepList();
    for (var i = 0; i < steps.length; i++) {
      if (steps[i].offsetParent !== null) return i;
    }
    return -1;
  }

  function firstInvalidStepIndex() {
    var steps = stepList();
    for (var i = 0; i < steps.length; i++) {
      if (steps[i].querySelector('[aria-invalid="true"], .hsfc-ErrorAlert')) return i;
    }
    return -1;
  }

  function returnToFirstError() {
    var target = firstInvalidStepIndex();
    var here = currentStepIndex();
    if (target === -1 || here === -1 || target >= here) return;

    walkingBack = true;
    returnTargetIndex = here;
    // The walk is a run of PREVIOUS clicks, one per step, and HubSpot needs a beat
    // to render between them. Unmasked, the visitor watches the form flick
    // backwards through every step in between; masked, it reads as one move.
    modal.classList.add('apply-popup--walking-back');

    function land() {
      walkingBack = false;
      modal.classList.remove('apply-popup--walking-back');
      var field = stepList()[target].querySelector('[aria-invalid="true"]');
      // Focus after unmasking, so the field the visitor is sent to is on screen
      // by the time the caret lands in it.
      if (field) field.focus();
    }

    function stepBack() {
      var at = currentStepIndex();
      if (at <= target) {
        land();
        return;
      }
      var buttons = stepList()[at].querySelectorAll('.hsfc-NavigationRow__Buttons button');
      if (buttons.length < 2) {
        land();
        return;
      }
      buttons[0].click();
      setTimeout(stepBack, 150);
    }

    // The mask is a CSS opacity transition, so starting the walk in the same tick
    // lets the first step change through at full opacity — exactly the flick this
    // is here to hide. Wait out the fade first; keep in step with the 0.2s
    // transition on .hs-form-html in apply-now-popup.css.
    setTimeout(stepBack, 200);
  }

  // A walk-back strands the visitor several steps behind the submit button, with
  // only a run of NEXT clicks through steps they already filled to get back. Once
  // the step they were sent to is clean again, offer the run as a single button.
  function removeReturnButton() {
    modal.querySelectorAll('.apply-popup__return').forEach(function (button) {
      button.remove();
    });
  }

  function maybeOfferReturn() {
    if (returnTargetIndex === -1 || walkingBack) return;
    var here = currentStepIndex();
    if (here === -1) return;
    if (here >= returnTargetIndex) {
      returnTargetIndex = -1;
      removeReturnButton();
      return;
    }
    var step = stepList()[here];
    var flagged = step.querySelector('[aria-invalid="true"], .hsfc-ErrorAlert, .apply-popup__error');
    if (flagged || stepErrors(step).length) {
      removeReturnButton();
      return;
    }
    var content = step.querySelector('.hsfc-Step__Content') || step;
    if (content.querySelector('.apply-popup__return')) return;
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'apply-popup__return';
    button.textContent = 'Back to final step';
    content.appendChild(button);
  }

  function fastForward() {
    var target = returnTargetIndex;
    var here = currentStepIndex();
    if (target === -1 || here === -1 || here >= target) return;

    removeReturnButton();
    walkingBack = true;
    modal.classList.add('apply-popup--walking-back');

    function land() {
      walkingBack = false;
      modal.classList.remove('apply-popup--walking-back');
      if (currentStepIndex() >= returnTargetIndex) returnTargetIndex = -1;
      var step = stepList()[currentStepIndex()];
      var flagged = step && step.querySelector('[aria-invalid="true"]');
      // Stopped short on another flagged step: put the caret on the problem.
      if (flagged) flagged.focus();
    }

    function stepForward() {
      var at = currentStepIndex();
      if (at === -1 || at >= target) {
        land();
        return;
      }
      var step = stepList()[at];
      var buttons = step.querySelectorAll('.hsfc-NavigationRow__Buttons button');
      var next = buttons[buttons.length - 1];
      // Advance only through steps that are complete and unflagged, and never
      // press a submit button — the last word on submitting stays with the
      // visitor.
      if (!next || next.type !== 'button') {
        land();
        return;
      }
      if (stepErrors(step).length || step.querySelector('[aria-invalid="true"], .hsfc-ErrorAlert')) {
        land();
        return;
      }
      next.click();
      setTimeout(function () {
        // No movement means HubSpot or the gate above held the step; stop here.
        if (currentStepIndex() === at) {
          land();
          return;
        }
        stepForward();
      }, 150);
    }

    // Same fade-first beat as returnToFirstError above.
    setTimeout(stepForward, 200);
  }

  modal.addEventListener('click', function (event) {
    var button = event.target.closest('.apply-popup__return');
    if (!button) return;
    event.preventDefault();
    fastForward();
  });

  modal.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('.hsfc-NavigationRow__Buttons button');
      if (button && button.type === 'submit') awaitingSubmitResult = true;
    },
    true
  );

  // HubSpot renders its errors asynchronously, so react to them appearing rather
  // than to the click.
  function handleSubmitErrors() {
    if (!awaitingSubmitResult || walkingBack) return;
    if (!modal.querySelector('.hsfc-ErrorAlert')) return;
    awaitingSubmitResult = false;
    returnToFirstError();
  }

  modal.classList.add('apply-popup--loading');
  function reveal() {
    modal.classList.remove('apply-popup--loading');
  }
  var revealFallback = setTimeout(reveal, 4000);

  window.addEventListener('hs-form-event:on-ready', function (event) {
    updateSteps();
    if (window.HubSpotFormsV4) {
      defaultPhoneToUs();
    }
    clearTimeout(revealFallback);
    reveal();
    var formRoot = modal.querySelector('.hs-form-html');
    if (formRoot) {
      new MutationObserver(function () {
        updateSteps();
        handleSubmitErrors();
        // Fires on every render, including HubSpot clearing its own error alert
        // and clearError() removing ours — the two moments a step turns clean.
        maybeOfferReturn();
        // At on-ready HubSpot has not resolved the phone country yet, so the first
        // assertion above lands before there is anything to override and the field
        // settles on Albania, its alphabetical fallback. Re-assert on each render
        // instead; assertUs no-ops once the dial code is +1 or the visitor types.
        assertUsDefault();
      }).observe(formRoot, { childList: true, subtree: true, attributes: true });
    }
  });
})();
